import { render, staticRenderFns } from "./InvolvedPhoneForm.vue?vue&type=template&id=6221d980&"
import script from "./InvolvedPhoneForm.vue?vue&type=script&lang=js&"
export * from "./InvolvedPhoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports